/* GriffinResponsiveAside.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXrunmFW%7Bbackground-color%3Avar(--ds-surface-sunken%2C%23f8f8f8)%7D%0A._0jFU0VN91d%7Bheight%3A100%25%7D%0A._46hvQmNHnM%7Bpadding-block-start%3Avar(--ds-space-300%2C24px)%7D%0A._0LQT5ENHnM%7Bpadding-inline-start%3Avar(--ds-space-300%2C24px)%7D%0A._03SyCPNHnM%7Bpadding-inline-end%3Avar(--ds-space-300%2C24px)%7D%0A%40media%20(min-width%3A90rem)%7B._17GTZbVa5s%7Bpadding-block-start%3Avar(--ds-space-400%2C2pc)%7D._2zv7VbVa5s%7Bpadding-inline-start%3Avar(--ds-space-400%2C2pc)%7D._2GdLiWVa5s%7Bpadding-inline-end%3Avar(--ds-space-400%2C2pc)%7D%7D%0A._17eyLENvrM%7Bborder-inline-start-width%3Avar(--ds-border-width%2C1px)%7D%0A._1y2ugf6wH8%7Bborder-inline-start-style%3Asolid%7D%0A._2HhxmA9r67%7Bborder-inline-start-color%3Avar(--ds-border%2C%230b120e24)%7D");








import React, { PropsWithChildren, useState } from 'react';
import { cx } from '@atlaskit/css';
import { Box as CompiledBox } from '@atlaskit/primitives/compiled/box';
import { GriffinMainGridAside, type defaultAsideWidths } from '@townsquare/griffin-main-grid/aside';
import { useOnMount } from '@townsquare/hooks';
import { ErrorBoundary } from '@townsquare/monitoring/error-boundary';
type Props = {
  hasNewHeader: boolean;
};
const compiledStyles = {
  aside: "_0KLXrunmFW"
};
const newStyles = {
  aside: "_0jFU0VN91d _46hvQmNHnM _0LQT5ENHnM _03SyCPNHnM _17GTZbVa5s _2zv7VbVa5s _2GdLiWVa5s",
  asideWithBorder: "_17eyLENvrM _1y2ugf6wH8 _2HhxmA9r67"
};

// Based on https://atlassian.design/foundations/grid-beta#side-navigation-and-aside
const getAsideWidth = (bodyWidth: number) => {
  if (bodyWidth < 1440) {
    return 320; // defaultSmall
  } else if (bodyWidth < 1768) {
    return 400; // default
  } else {
    return 504; // defaultLarge
  }
};
export const GriffinResponsiveAside = ({
  children,
  hasNewHeader
}: PropsWithChildren<Props>): React.JSX.Element => {
  const [asideWidth, setAsideWidth] = useState<defaultAsideWidths>();
  useOnMount(() => {
    const resizeObserver = new ResizeObserver(([entry]: ResizeObserverEntry[]) => {
      const {
        width
      } = entry.contentRect;
      setAsideWidth(getAsideWidth(width));
    });
    resizeObserver.observe(window.document.body);
    return () => {
      resizeObserver.unobserve(window.document.body);
    };
  });
  return <ErrorBoundary variant="aside">
			<GriffinMainGridAside defaultWidth={asideWidth} xcss={!hasNewHeader && compiledStyles.aside}>
				<CompiledBox xcss={cx(newStyles.aside, hasNewHeader ? newStyles.asideWithBorder : undefined)}>
					{children}
				</CompiledBox>
			</GriffinMainGridAside>
		</ErrorBoundary>;
};